'use client'

// Auth-aware swap for the dashboard hero (R2/R3): both variants arrive server-rendered as
// children; the session (client-hydrated) picks which one shows. Default = signed-out
// (what crawlers and the static build see), signed-in swaps after hydration.
import React from 'react'
import { useSupabaseAuth } from '@/context/supabaseContext'
import { SUPABASE_CONFIGURED } from '@/lib/supabase/client'
import { DashboardTitle } from './title'

export function HeroAuthSwap({
  signedOut,
  signedIn,
}: {
  signedOut: React.ReactNode
  signedIn: React.ReactNode
}) {
  const { user, isLoaded } = useSupabaseAuth()
  if (!SUPABASE_CONFIGURED) return <>{signedOut}</>
  return isLoaded && user ? <>{signedIn}</> : <>{signedOut}</>
}

/** Signed-in hero title: greets by first name from the hydrated session. */
export function SignedInHeroTitle({ title }: { title: string }) {
  const { user } = useSupabaseAuth()
  const fullName =
    (user?.user_metadata?.full_name as string | undefined) ||
    (user?.user_metadata?.name as string | undefined) ||
    ''
  const firstName = fullName.split(/\s+/)[0] || null
  return <DashboardTitle title={title} isSignedIn firstName={firstName} />
}
